export default {
  inactive: 'INACTIVE',
  active: 'ACTIVE',
};

export const prescriptionReviewStatus = {
  PRESCRIPTION_DIRECTION_REVIEW: 'Direction review',
  PRESCRIPTION_DUPLICATE_REVIEW: 'Duplicate review',
  DRUG_PROFILE_REVIEW: 'Drug review',
  PRESCRIPTION_REVIEW: 'Prescription review',
  MULTI_RX_REVIEW: 'Multi rx review',
  SHIP_LATER_REVIEW: 'Ship later review',
  SHIPPING_ADDRESS_REVIEW: 'Shipping address review',
  PROVIDER_CLARIFICATION_REVIEW: 'Provider clarification review',
  MANUAL_ORDER_REVIEW: 'Manual order review',
  OTHER_REVIEW: 'Other review',
};

export const PrescriptionFormattedStatus = {
  PRESCRIPTION_DIRECTION_REVIEW: 'Direction review',
  PRESCRIPTION_DUPLICATE_REVIEW: 'Duplicate review',
  DRUG_PROFILE_REVIEW: 'Drug review',
  PRESCRIPTION_REVIEW: 'Prescription review',
  MULTI_RX_REVIEW: 'Multi rx review',
  SHIP_LATER_REVIEW: 'Ship later review',
  SHIPPING_ADDRESS_REVIEW: 'Shipping address review',
  PROVIDER_CLARIFICATION_REVIEW: 'Provider clarification review',
  MANUAL_ORDER_REVIEW: 'Manual order review',
  OTHER_REVIEW: 'Other review',
  COMPOUNDING_STATE_NOT_LICENSED_REVIEW: 'Compounding state not licensed review',
};
